import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'

import { BehaviorSubject } from 'rxjs'

import { UserFacade } from '~/core/features'
import { EGuardEntityName, EGuardSectionName } from '~/core/models'

import { UserAccessBlockComponent } from '../user-access-block/user-access-block.component'

@Component({
  selector: 'app-user-access',
  templateUrl: './user-access.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, UserAccessBlockComponent],
})
export class UserAccessComponent {
  readonly userFacade = inject(UserFacade)

  readonly isGranted$ = new BehaviorSubject<boolean>(false)

  readonly sectionName = input<EGuardSectionName | null>()
  readonly entityName = input<EGuardEntityName | null>()
  readonly entityField = input<string>()

  constructor() {}
}
